import React, { Component } from 'react';
import { StaticQuery, graphql } from 'gatsby';
import { ProductListItem } from '.';
import { Wrapper } from '../common';
import './RelatedProducts.scss';

const RelatedProductsTemplate = (props) => {
  const {
    relatedProducts,
    siteMetadata,
  } = props;
  const { shopSlug } = siteMetadata;
  const relatedProductItems = relatedProducts && relatedProducts.edges.map(product => product.node);
  return (
    <div className="related-products-block">
      <Wrapper isBound>
        <h2 className="title">You may also like...</h2>
        <div className="related-products">
          {relatedProductItems && relatedProductItems.map(product => (
            <ProductListItem
              key={product.handle}
              shopSlug={shopSlug}
              {...product}
            />
          ))}
        </div>
      </Wrapper>
    </div>
  );
};

class RelatedProducts extends Component {
  render() {
    return (
      <StaticQuery
        query={graphql`
          query RelatedProductsQuery {
            relatedProducts: allShopifyProduct(
              limit: 2,
              sort: { fields: [createdAt], order: DESC },
            ) {
              edges {
                node {
                  id
                  title
                  handle
                  createdAt
                  images {
                    id
                    originalSrc
                    localFile {
                      childImageSharp {
                        fluid(maxWidth: 800) {
                          ...GatsbyImageSharpFluid_withWebp
                        }
                      }
                    }
                  }
                  variants {
                    price
                  }
                }
              }
            }
          }
        `}
        render={data => <RelatedProductsTemplate {...this.props} relatedProducts={data.relatedProducts} />}
      />
    );
  }
}


export default RelatedProducts;
